import React from 'react';
import ReactDOM from 'react-dom/client';

import { Provider as StoreProvider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { getSentryReact19RootOptions, sentrySetup } from '@/services/logger/sentry';

import { store } from './store/store';
import router from './router';

import '@comicrelief/component-library/dist/style.css';
import './index.css';

// Sentry requires its setup runs before the rest of the application is loaded
sentrySetup();

ReactDOM.createRoot(document.getElementById('root')!, getSentryReact19RootOptions()).render(
  <React.StrictMode>
    <StoreProvider store={store}>
      <RouterProvider router={router} />
    </StoreProvider>
  </React.StrictMode>
);
